import React, { useEffect, useState } from "react";
import ReactSwitch from "react-switch";
import { useTranslation } from "react-i18next";


const OptinPage = ({optinToLogin}) => {
    const { t } = useTranslation();
    const [smsVerification, setSmsVerification] = useState(true);
    const [marketing, setMarketing] = useState(true);

    useEffect(() => {
        optinToLogin({smsVerification, marketing});
    } , [smsVerification, marketing])
    
    return (

        <div style={{display:"flex", flexWrap:"wrap"}}>
            <div className="radio-input">
                <ReactSwitch
                    checked={smsVerification}
                    id="ticketable"
                    alt="Toggle ticketable"
                    height={20}
                    width={40}
                    onColor="#459e39"
                    onChange={(c, e) => setSmsVerification(c)}
                />
                <label
                    onClick={() => setSmsVerification(!smsVerification)}
                    style={{ marginLeft: "10px" }}
                >
                    {t("OptinPage.iconsenttoSMSverificationcodesforaddedsecurityatspecialevents")}
                </label>
            </div>
            <div className="radio-input">
                <ReactSwitch
                    checked={marketing}
                    id="ticketable"
                    alt="Toggle ticketable"
                    height={20}
                    width={40}
                    onColor="#459e39"
                    onChange={(c, e) => setMarketing(c)}
                />
                <label
                    onClick={() => setMarketing(!marketing)}
                    style={{ marginLeft: "10px" }}
                >
                    {t("OptinPage.signupforexcitingeventnewsandexclusiveoffersfromGroovoo")}
                </label>
            </div>
        </div >

    )
}

export default OptinPage;




